import React, { useState } from "react";
import { auth } from "../firebase/config";
import { signInWithEmailAndPassword } from "firebase/auth";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { userRole } = useAuth();

  async function handleLogin(e) {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      setError("Invalid email or password. Please try again.");
      setLoading(false);
    }
  }

  React.useEffect(() => {
    if (userRole === "scholar") navigate("/scholar");
    if (userRole === "facilitator") navigate("/facilitator");
    if (userRole === "program_lead") navigate("/program-lead");
  }, [userRole, navigate]);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Outfit:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { font-family: 'Outfit', sans-serif; }
        .login-wrap { display: flex; min-height: 100vh; }
        .login-left { width: 46%; background: #060D1A; display: flex; flex-direction: column; justify-content: space-between; padding: 56px 56px; position: relative; overflow: hidden; }
        .login-right { flex: 1; background: #ffffff; display: flex; flex-direction: column; justify-content: space-between; padding: 56px 56px; }
        .rings { position: absolute; bottom: -120px; right: -120px; width: 520px; height: 520px; pointer-events: none; }
        .ring { position: absolute; border-radius: 50%; transform: translate(-50%, -50%); top: 50%; left: 50%; }
        .login-tag { display: inline-block; background: rgba(56,189,248,0.1); border: 1px solid rgba(56,189,248,0.25); color: #38BDF8; font-family: 'Outfit', sans-serif; font-size: 10px; font-weight: 600; padding: 4px 12px; border-radius: 999px; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 20px; }
        .login-input { width: 100%; padding: 14px 16px; border-radius: 12px; border: 2px solid #e8e8e8; background: #f5f5f5; font-size: 14px; font-family: 'Outfit', sans-serif; color: #0A1628; }
        .login-input:focus { border-color: #0038A8; outline: none; background: #fff; }
        .signin-btn { width: 100%; padding: 15px; border-radius: 12px; background: #0038A8; color: #ffffff; border: none; font-family: 'Outfit', sans-serif; font-size: 15px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; cursor: pointer; }
        .signin-btn:hover { opacity: 0.9; }
        .register-btn { width: 100%; padding: 14px; border-radius: 12px; background: #ffffff; border: 2.5px solid #C9A84C; color: #C9A84C; font-family: 'Outfit', sans-serif; font-size: 15px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; cursor: pointer; text-decoration: none; display: block; text-align: center; }
        .register-btn:hover { background: #fef9ec; }
        .mobile-top { display: none; background: #060D1A; padding: 32px 24px 28px; position: relative; overflow: hidden; }
        @media (max-width: 768px) {
          .login-wrap { flex-direction: column; }
          .login-left { display: none; }
          .mobile-top { display: block; }
          .login-right { padding: 32px 24px 40px; }
        }
      `}</style>

      <div className="login-wrap">

        <div className="mobile-top">
          <div className="login-tag">Inside Out Leadership</div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#fff", letterSpacing: -1, lineHeight: 1.1 }}>LEAD</span>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#0038A8", letterSpacing: -1, lineHeight: 1.1 }}>NOW</span>
          </div>
          <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#C9A84C", margin: 0, lineHeight: 1.6, fontWeight: 600 }}>
            A leadership development program of LGU of Pasig and Victory Pasig
          </p>
        </div>

        <div className="login-left">
          <div className="rings">
            <div className="ring" style={{ width: 100, height: 100, border: "1px solid rgba(201,168,76,0.2)", background: "rgba(201,168,76,0.02)" }} />
            <div className="ring" style={{ width: 210, height: 210, border: "1px solid rgba(201,168,76,0.15)" }} />
            <div className="ring" style={{ width: 340, height: 340, border: "1px solid rgba(255,255,255,0.12)" }} />
            <div className="ring" style={{ width: 500, height: 500, border: "1px solid rgba(255,255,255,0.07)" }} />
            <div className="ring" style={{ width: 8, height: 8, background: "rgba(201,168,76,0.4)", border: "none" }} />
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -195px)", fontFamily: "'Outfit', sans-serif", fontSize: 8, fontWeight: 600, color: "rgba(255,255,255,0.18)", letterSpacing: 2, textTransform: "uppercase", whiteSpace: "nowrap" }}>Influence</div>
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -128px)", fontFamily: "'Outfit', sans-serif", fontSize: 8, fontWeight: 600, color: "rgba(255,255,255,0.22)", letterSpacing: 2, textTransform: "uppercase", whiteSpace: "nowrap" }}>Habits</div>
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -62px)", fontFamily: "'Outfit', sans-serif", fontSize: 8, fontWeight: 600, color: "rgba(201,168,76,0.3)", letterSpacing: 2, textTransform: "uppercase", whiteSpace: "nowrap" }}>Identity</div>
            <div style={{ position: "absolute", top: "50%", left: "50%", transform: "translate(-50%, -20px)", fontFamily: "'Outfit', sans-serif", fontSize: 8, fontWeight: 600, color: "rgba(201,168,76,0.35)", letterSpacing: 2, textTransform: "uppercase", whiteSpace: "nowrap" }}>Beliefs</div>
          </div>

          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="login-tag">Inside Out Leadership</div>
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 64, fontWeight: 600, color: "#ffffff", letterSpacing: -1, lineHeight: 1.1 }}>LEAD</span>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 64, fontWeight: 600, color: "#0038A8", letterSpacing: -1, lineHeight: 1.1 }}>NOW</span>
            </div>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: "#C9A84C", margin: 0, lineHeight: 1.7, fontWeight: 600 }}>
              A leadership development program of<br />LGU of Pasig and Victory Pasig
            </p>
          </div>

          <div style={{ position: "relative", zIndex: 1, height: 20 }} />
        </div>

        <div className="login-right">
          <div style={{ width: "100%", maxWidth: 400, margin: "auto" }}>
            <div style={{ marginBottom: 32 }}>
              <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: 28, fontWeight: 700, color: "#060D1A", marginBottom: 6, letterSpacing: -0.3 }}>
                Hey, welcome back.
              </h2>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: "#aaa" }}>
                Sign in to continue your journey.
              </p>
            </div>

            <form onSubmit={handleLogin} style={{ display: "flex", flexDirection: "column", gap: 16, marginBottom: 24 }}>
              <div>
                <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 600, color: "#777", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Email</div>
                <input
                  className="login-input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  required
                />
              </div>
              <div>
                <div style={{ fontFamily: "'Outfit', sans-serif", fontSize: 11, fontWeight: 600, color: "#777", textTransform: "uppercase", letterSpacing: 1, marginBottom: 8 }}>Password</div>
                <input
                  className="login-input"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="••••••••"
                  required
                />
              </div>
              {error && (
                <p style={{ color: "#e53935", fontSize: 13, textAlign: "center" }}>{error}</p>
              )}
              <div style={{ display: "flex", flexDirection: "column", gap: 12, marginTop: 8 }}>
                <button type="submit" className="signin-btn" disabled={loading}>
                  {loading ? "Signing in..." : "Sign In"}
                </button>
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <div style={{ flex: 1, height: 1, background: "#ebebeb" }} />
                  <span style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#bbb", fontWeight: 500 }}>or</span>
                  <div style={{ flex: 1, height: 1, background: "#ebebeb" }} />
                </div>
                <Link to="/register" className="register-btn">
                  Create Account
                </Link>
              </div>
            </form>
          </div>

          <p style={{ fontFamily: "'Outfit', sans-serif", textAlign: "center", fontSize: 9, color: "rgba(0,0,0,0.15)", letterSpacing: 1, textTransform: "uppercase" }}>
            © 2026 GOSECOND INC. All rights reserved.
          </p>
        </div>

      </div>
    </>
  );
}